<template>
  <div
    class="associate-patient"
    :style="{
      paddingBottom: patientProfileList?.length > 2 ? '5px' : ''
    }"
  >
    <div :class="isfold && 'fold'" class="bodyPadding">
      <div
        class="content"
        :class="item.selected === 1 && 'select'"
        v-for="(item, index) in patientProfileList"
        :key="index"
        @click="handlePatientFile(item)"
      >
        <div v-if="item.selected === 1" class="current">本次就诊人</div>
        <div class="info">
          <span class="name">
            {{ item.patientProfileCommonVO?.patientProfileName || '--' }}
          </span>
          <span
            v-if="item.patientProfileCommonVO?.gender || item.patientProfileCommonVO?.gender === 0"
          >
            {{ ['女', '男'][item.patientProfileCommonVO?.gender] || '--' }}
          </span>
          <span v-if="item.patientProfileCommonVO?.age || item.patientProfileCommonVO?.age === 0">
            {{ `${item.patientProfileCommonVO?.age}岁` }}
          </span>
          <span class="patient">患者</span>
          <span class="relation">
            {{ patientRelationMap[item.patientProfileCommonVO?.relation] || '其他' }}
          </span>
        </div>
        <div class="remark-box">
          <div class="remark">
            <div class="type">患者协同备注</div>
            <a-tooltip placement="topLeft">
              <template #title>
                <div>{{ item.patientRemark }}</div>
              </template>
              <div class="ellipsis-text">{{ item.patientRemark }}</div>
            </a-tooltip>
            <div @click.stop>
              <RemarkPopover
                mode="patient"
                @updateRemark="updatePatientProfileRemark"
                :remarkData="{ beRemarkContent: item.patientRemark }"
                :patientProfileId="item.patientProfileCommonVO?.patientProfileId"
              >
                <template #content>
                  <div class="edit">编辑</div>
                </template>
              </RemarkPopover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fold-text" @click="handleFold" v-if="patientProfileList?.length > 2">
      {{ isfold ? '展开全部' : '收起' }}
      <img :src="isfold ? expand : fold" alt="" class="expand" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { useStore } from 'vuex'
import expand from '@/assets/img/expand.png'
import fold from '@/assets/img/fold.png'
import { getPatientProfileList } from '@/api/workPlace/workOrder'
import RemarkPopover from '@/components/RemarkPopover'
import { patientRelationMap } from '@/utils/globalMap'

const props = defineProps({
  ucPatientId: {
    type: String,
    default: ''
  },
  ucDoctorId: {
    type: String,
    default: ''
  },
  patientId: {
    type: String,
    default: ''
  },
  doctorId: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['getRemark', 'getPatientProfileLists'])
const store = useStore()
const patientProfileList = ref([])
const isfold = ref(true)

// 获取就诊人列表
const getPatientProfile = async () => {
  try {
    const params = {
      ucPatientId: props.ucPatientId,
      ucDoctorId: props.ucDoctorId
    }
    const result = await getPatientProfileList(params)
    patientProfileList.value = result || []
    emit('getPatientProfileLists', result)
  } catch (error) {
    console.log(error)
  }
}

const handleFold = () => {
  isfold.value = !isfold.value
}

// 编辑就诊人协同备注
const updatePatientProfileRemark = () => {
  getPatientProfile()
  emit('getRemark')
}

// 打开就诊人患者档案
const handlePatientFile = item => {
  const param = {
    patientId: props.patientId,
    doctorId: props.doctorId,
    patientType: 1,
    profileId: item.patientProfileCommonVO?.patientProfileId
  }
  store.dispatch('patientFile/openModal', param)
}
watch(
  [props.ucDoctorId, props.ucPatientId],
  () => {
    getPatientProfile()
  },
  { immediate: true }
)
</script>

<style scoped lang="scss">
.associate-patient {
  & > div:nth-child(2) {
    transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    max-height: 1000px;
  }
  .title {
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    margin-bottom: 14px;
  }
  .content {
    padding: 13px;
    border-radius: 8px;
    border: 1px solid #e3e3e3;
    margin-bottom: 12px;
    cursor: pointer;
    .info {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      color: #333;
      margin-bottom: 13px;
      .name {
        max-width: 45%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        margin-right: 10px;
      }
      .patient {
        padding: 3px 6px;
        font-weight: 400;
        font-size: 10px;
        color: #ffa940;
        border-radius: 4px;
        background: #ffeed9;
        line-height: 10px;
      }
      .relation {
        border: 1px solid #c7d1dbb3;
        padding: 2px 5px;
        font-weight: 400;
        font-size: 10px;
        color: #8088a5;
        border-radius: 4px;
        background: #ffffff;
        line-height: 10px;
      }
    }
    .remark-box {
      padding: 7px 12px 2px 12px;
      border-radius: 4px;
      background-color: rgba(216, 216, 216, 0.2);
      font-weight: 400;
      font-size: 12px;
      color: #f78408;
      line-height: 16px;
      .remark {
        display: flex;
        margin-bottom: 5px;
        .type {
          font-weight: 400;
          font-size: 12px;
          color: #666;
          margin-right: 14px;
          width: 25%;
        }
      }
    }
  }
  .select {
    position: relative;
    border: 1px solid #1890ffcc;
    .current {
      position: absolute;
      right: -1px;
      top: -1px;
      padding: 3px 8px;
      font-weight: 400;
      font-size: 12px;
      color: #fff;
      border-radius: 0 8px 0 8px;
      background: #1890ff;
      border-radius: 0 8px 0 8px;
    }
  }
  .fold {
    max-height: 215px !important;
  }
  .fold-text {
    position: absolute;
    bottom: 0px;
    width: 100%;
    background: #fff;
    padding: 5px 0;
    cursor: pointer;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #666;
    .expand {
      width: 16px;
      height: 16px;
    }
  }
  .ellipsis-text {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .edit {
    cursor: pointer;
    color: #1890ff;
    font-size: 12px;
    font-weight: 400;
  }
}
.bodyPadding {
  padding: 0 16px;
}
</style>
